(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7183],{

/***/ 46208:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/car-finance",
      function () {
        return __webpack_require__(16320);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 16320:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* reexport */ FeatureCarFinance; }
});

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../node_modules/@cinch-labs/design-system/dist/index.esm.js
var index_esm = __webpack_require__(55370);
// EXTERNAL MODULE: ../../../libs/consumer-lending/feature-car-finance/src/lib/components/finance-explained/finance-explained.module.css
var finance_explained_module = __webpack_require__(32857);
var finance_explained_module_default = /*#__PURE__*/__webpack_require__.n(finance_explained_module);
// EXTERNAL MODULE: ../../../libs/shared/ui/src/index.ts + 57 modules
var src = __webpack_require__(72284);
;// CONCATENATED MODULE: ../../../libs/consumer-lending/feature-car-finance/src/lib/components/finance-explained/assets/ways-to-buy.jpeg
/* harmony default export */ var ways_to_buy = ({"src":"https://landing-articles.snc-prod.aws.cinch.co.uk/_next/static/media/ways-to-buy.787312e4.jpeg","height":843,"width":1264,"blurDataURL":"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoKCgoKCgsMDAsPEA4QDxYUExMUFiIYGhgaGCIzICUgICUgMy03LCksNy1RQDg4QFFeT0pPXnFlZXGPiI+7u/sBCgoKCgoKCwwMCw8QDhAPFhQTExQWIhgaGBoYIjMgJSAgJSAzLTcsKSw3LVFAODhAUV5PSk9ecWVlcY+Ij7u7+//CABEIAAUACAMBIgACEQEDEQH/xAAoAAEBAAAAAAAAAAAAAAAAAAAABAEBAQAAAAAAAAAAAAAAAAAAAgP/2gAMAwEAAhADEAAAALgb/wD/xAAbEAADAAIDAAAAAAAAAAAAAAABAgQAAxMycf/aAAgBAQABPwCwzzQMF0sSid+Qhj6Rn//EABgRAAIDAAAAAAAAAAAAAAAAAAABAgMh/9oACAECAQE/ALJNPD//xAAYEQACAwAAAAAAAAAAAAAAAAAAAQIDIf/aAAgBAwEBPwCuKa0//9k=","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ../../../libs/consumer-lending/feature-car-finance/src/lib/components/finance-explained/finance-explained.tsx





function FinanceExplained({ i18n  }) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* Wrapper */.im, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
            className: (finance_explained_module_default()).youtubeWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                    element: "h2",
                    className: (finance_explained_module_default()).youtubeWrapperTitle,
                    fontSize: index_esm/* TextFontSizes.3xl */.Xo["3xl"],
                    fontWeight: index_esm/* TextFontWeights.bold */.Ax.bold,
                    lineHeight: index_esm/* TextLineHeights.display */.ET.display,
                    children: i18n.sectionTitle
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Youtube */.hx, {
                    videoId: "rHYjjHiJcro",
                    title: i18n.videoTitle,
                    customThumbnail: ways_to_buy.src,
                    buttonLabel: `${i18n.cta.start} ${i18n.videoTitle} ${i18n.cta.end}`,
                    showNewPlayIcon: true
                })
            ]
        })
    });
}
/* harmony default export */ var finance_explained = (FinanceExplained);

// EXTERNAL MODULE: ../../../node_modules/classnames/index.js
var classnames = __webpack_require__(95685);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../../libs/consumer-lending/feature-car-finance/src/lib/components/finance-lenders/finance-lenders.module.css
var finance_lenders_module = __webpack_require__(65410);
var finance_lenders_module_default = /*#__PURE__*/__webpack_require__.n(finance_lenders_module);
;// CONCATENATED MODULE: ../../../libs/consumer-lending/feature-car-finance/src/lib/components/finance-lenders/finance-lenders.tsx





function FinanceLenders({ i18n , className  }) {
    const STATIC_ASSET_DOMAIN = i18n.endpoints.staticAssetBaseUrl;
    const lenders = [
        {
            name: "Black Horse",
            webpSrc: `${STATIC_ASSET_DOMAIN}/finance/bh-logo.webp`,
            fallbackSrc: `${STATIC_ASSET_DOMAIN}/finance/bh-logo.png`
        },
        {
            name: "Evolution Funding",
            webpSrc: `${STATIC_ASSET_DOMAIN}/finance/evo-logo.webp`,
            fallbackSrc: `${STATIC_ASSET_DOMAIN}/finance/evo-logo.png`
        },
        {
            name: "Moto Novo Finance",
            webpSrc: `${STATIC_ASSET_DOMAIN}/finance/moto-novo.webp`,
            fallbackSrc: `${STATIC_ASSET_DOMAIN}/finance/moto-novo.png`
        },
        {
            name: "Santander Consumer Finance",
            webpSrc: `${STATIC_ASSET_DOMAIN}/finance/santander-cf-logo.webp`,
            fallbackSrc: `${STATIC_ASSET_DOMAIN}/finance/santander-cf-logo.png`
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
        className: classnames_default()((finance_lenders_module_default()).lendingPartners, className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(src/* Wrapper */.im, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                    element: "h2",
                    fontSize: index_esm/* TextFontSizes.4xl */.Xo["4xl"],
                    fontWeight: index_esm/* TextFontWeights.bold */.Ax.bold,
                    lineHeight: index_esm/* TextLineHeights.display */.ET.display,
                    className: (finance_lenders_module_default()).lendingPartnersMainTitle,
                    children: i18n.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                    fontSize: index_esm/* TextFontSizes.s */.Xo.s,
                    fontWeight: index_esm/* TextFontWeights.book */.Ax.book,
                    children: i18n.text
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (finance_lenders_module_default()).lenderImagesContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: (finance_lenders_module_default()).lenderImages,
                        children: lenders.map((lender)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: (finance_lenders_module_default()).lenderImageItem,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
                                    className: (finance_lenders_module_default()).lenderImageContainer,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                            srcSet: lender.webpSrc,
                                            type: "image/webp"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: lender.fallbackSrc,
                                            alt: lender.name,
                                            loading: "lazy",
                                            className: (finance_lenders_module_default()).lenderImage
                                        })
                                    ]
                                })
                            }, lender.name))
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var finance_lenders = (FinanceLenders);

// EXTERNAL MODULE: ../../../libs/consumer-lending/feature-car-finance/src/lib/components/find-a-car-cta/find-a-car-cta.module.css
var find_a_car_cta_module = __webpack_require__(45214);
var find_a_car_cta_module_default = /*#__PURE__*/__webpack_require__.n(find_a_car_cta_module);
;// CONCATENATED MODULE: ../../../libs/consumer-lending/feature-car-finance/src/lib/components/find-a-car-cta/find-a-car-cta.helpers.ts

const scrollToElement = (element, scrollTarget, adjustment)=>{
    if (!document || !element.current) {
        return;
    }
    let scrollPosition = scrollTarget || element.current.getBoundingClientRect().top + window.scrollY;
    if (adjustment) {
        scrollPosition += adjustment;
    }
    try {
        window.scrollTo({
            top: scrollPosition,
            behavior: "scrollBehavior" in document.documentElement.style ? "smooth" : "auto"
        });
    } catch  {
        window.scrollTo(0, scrollPosition);
    }
};

// EXTERNAL MODULE: ../../../libs/shared/analytics/src/index.ts + 26 modules
var analytics_src = __webpack_require__(40731);
;// CONCATENATED MODULE: ../../../libs/consumer-lending/feature-car-finance/src/lib/tracking/tracking-events.ts
// Most tracking events are passed into the library.
// In some cases where features are not context specific, we may use the events below.

const financeBudgetTopButton = ()=>({
        eventName: "Finance budget calculator - Banner button click to scroll",
        type: analytics_src/* TrackingEventTypes.ADOBE */.md.ADOBE,
        data: {
            event: {
                action: "budget calculator",
                category: "finance page",
                name: "click",
                label: "banner button"
            }
        }
    });
const financeBudgetCalculator = (type, budget)=>({
        eventName: "Finance budget calculator - Search all cars",
        type: analytics_src/* TrackingEventTypes.ADOBE */.md.ADOBE,
        data: {
            event: {
                action: "budget calculator",
                category: "finance page",
                name: "click",
                label: `${type} | ${budget}`
            }
        }
    });
const understandingFinanceClick = (title, question)=>({
        eventName: "Finance content page - Understanding finance click",
        type: analytics_src/* TrackingEventTypes.ADOBE */.md.ADOBE,
        data: {
            event: {
                action: title,
                category: "finance page",
                name: "click",
                label: question
            }
        }
    });
const calculatorHpExplainedSelected = ()=>({
        eventName: "Finance - Selected HP Explained",
        type: analytics_src/* TrackingEventTypes.ADOBE */.md.ADOBE,
        data: {
            event: {
                action: "open",
                category: "tooltip",
                name: "click",
                label: "hp-explained"
            }
        }
    });
const calculatorPcpExplainedSelected = ()=>({
        eventName: "Finance - Selected PCP Explained",
        type: analytics_src/* TrackingEventTypes.ADOBE */.md.ADOBE,
        data: {
            event: {
                action: "open",
                category: "tooltip",
                name: "click",
                label: "pcp-explained"
            }
        }
    });
const searchAllCarsClick = ()=>({
        eventName: "Finance content page - Search all cars",
        type: analytics_src/* TrackingEventTypes.ADOBE */.md.ADOBE,
        data: {
            event: {
                action: "search all cars cta click bottom",
                category: "finance page",
                name: "click"
            }
        }
    });

;// CONCATENATED MODULE: ../../../libs/consumer-lending/feature-car-finance/src/lib/components/find-a-car-cta/find-a-car-cta.tsx







function FindACarCta({ i18n , triggerPointRef  }) {
    const { trackEvent  } = (0,analytics_src/* useAnalytics */.z$)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* Wrapper */.im, {
        className: {
            container: (find_a_car_cta_module_default()).findACarCtaContainer,
            inner: (find_a_car_cta_module_default()).findACarCtaInner
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Primary */.sq, {
            classNames: {
                button: (find_a_car_cta_module_default()).findACarCta
            },
            onClick: ()=>{
                scrollToElement(triggerPointRef);
                trackEvent(financeBudgetTopButton());
            },
            children: i18n.ctaText
        })
    });
}
/* harmony default export */ var find_a_car_cta = (FindACarCta);

// EXTERNAL MODULE: ../../../node_modules/react-final-form/dist/react-final-form.es.js + 5 modules
var react_final_form_es = __webpack_require__(51080);
// EXTERNAL MODULE: ../../../libs/consumer-lending/feature-car-finance/src/lib/components/find-a-car/find-a-car.module.css
var find_a_car_module = __webpack_require__(21714);
var find_a_car_module_default = /*#__PURE__*/__webpack_require__.n(find_a_car_module);
;// CONCATENATED MODULE: ../../../libs/consumer-lending/feature-car-finance/src/lib/components/find-a-car/assets/lady-with-car-keys-large.png
/* harmony default export */ var lady_with_car_keys_large = ({"src":"https://landing-articles.snc-prod.aws.cinch.co.uk/_next/static/media/lady-with-car-keys-large.e0da19c1.png","height":590,"width":461,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAYAAADaxo44AAAA00lEQVR4nAHIADf/AcvCu/79690Bv8bNANjKvQDf4e0AwuIC/wHKrqD/+uzkAMPQ4gAfKC8A6P/8AMWjmwABsqSf//bSvQAEGzYAOB0rAO8iEgDCloQAAcTDwP8N5scAID1UAOjl7gD7BgcA0aSTAAGOiYr/PyQJAPsDDADIzdoA4d7jABPt1wABZlpb/2RMMgD8/wEA593aAB4cGgD++wUAAUo7Pv9zVjcAIycjAP79+wDazc0AHjZPAAGblpL+HfnrARwWBAD3/AIArpOWAExsff/lcFuuyQIaigAAAABJRU5ErkJggg==","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ../../../libs/consumer-lending/feature-car-finance/src/lib/components/find-a-car/assets/lady-with-car-keys-small.png
/* harmony default export */ var lady_with_car_keys_small = ({"src":"https://landing-articles.snc-prod.aws.cinch.co.uk/_next/static/media/lady-with-car-keys-small.13cfff73.png","height":240,"width":375,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAiElEQVR42gF9AIL/AMCij39kWl5TUTMkJi4jI0I1MFo3L3tnYgCxi3XHp6rNwMKgemiTcmlAOT9lSEWKg4YAzbGa08K5ppydqnFak3FrgHZ/eWpwhnV2ALuZgsOegreKbr2NfJRcS4twb1c4PYJJNwC2kHzdsY6tfGHXvLbYubTJs7Ccjoabg3qhnTx/3WIaLwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});
// EXTERNAL MODULE: ../../../libs/shared/util/src/index.ts + 25 modules
var util_src = __webpack_require__(37479);
;// CONCATENATED MODULE: ../../../libs/consumer-lending/feature-car-finance/src/lib/components/find-a-car/find-a-car.helpers.ts
/* eslint-disable @typescript-eslint/no-explicit-any */ 
const getActiveCtaText = (template, budget)=>(0,util_src/* interpolateI18n */.uR)(template, {
        budget: (0,util_src/* currencyValueFormatter */.DY)(budget)
    }).join("");
const getFiltredUrl = (baseCtaUrl, toPrice, useMonthly)=>{
    const parameters = {
        toPrice,
        useMonthly,
        sortingCriteria: useMonthly ? 12 : 10
    };
    return `${baseCtaUrl}?${Object.entries(parameters).map(([key, value])=>`${key}=${value}`).join("&")}`;
};
const convertToPence = (value)=>{
    if (typeof value === "undefined") return;
    if (value === "0") {
        return value;
    }
    const onlyNums = Math.round(Number.parseFloat(value.replace(/[^\d.?]/g, "")));
    if (Number.isNaN(onlyNums)) {
        return "";
    }
    return onlyNums * 100;
};
const formatToPounds = (value)=>{
    if (typeof value === "undefined" || typeof value === "string" && Number.isNaN(Number.parseFloat(value))) {
        return "";
    }
    if (typeof value === "number") {
        return formatPenceToPounds(value);
    }
    return formatPenceToPounds(Number.parseFloat(value));
};
const formatPenceToPounds = (value)=>`£${Math.ceil(value / 100)}`;

;// CONCATENATED MODULE: ../../../libs/consumer-lending/feature-car-finance/src/lib/components/find-a-car/find-a-car-radio-field/find-a-car-radio-field.tsx
/* eslint-disable @typescript-eslint/no-explicit-any */ 

const FindACarRadioField = ({ classNames , input , label ="" , helpText , options =[] , onBlur , onFocus , onChange , sharedSubLabelText , sharedSubLabelClass  })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* InlineRadioField */.f1, {
                ...input,
                value: input.value,
                helpText: helpText,
                onBlur: (e)=>{
                    input.onBlur(e);
                    if (onBlur) onBlur(e);
                },
                onFocus: (e)=>{
                    input.onFocus(e);
                    if (onFocus) onFocus(e);
                },
                onChange: (e)=>{
                    input.onChange(e);
                    if (onChange) onChange(e);
                },
                label: label,
                options: options.map((option, index)=>{
                    option.id = `${input.name}-${index}`;
                    return option;
                }),
                classNames: classNames
            }),
            !!sharedSubLabelText && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: sharedSubLabelClass,
                children: sharedSubLabelText
            })
        ]
    });
/* harmony default export */ var find_a_car_radio_field = (FindACarRadioField);

;// CONCATENATED MODULE: ../../../libs/consumer-lending/feature-car-finance/src/lib/components/find-a-car/find-a-car-text-field/find-a-car-text-field.tsx
/* eslint-disable @typescript-eslint/no-explicit-any */ 

const FindACarTextField = ({ input , onBlur , label , inputRef , onFocus , onChange , ...rest })=>{
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(index_esm/* TextField */.nv, {
        ...rest,
        label: label,
        id: rest.id,
        name: input.name,
        type: input.type ? input.type : "text",
        value: input.value,
        onChange: (e)=>{
            input.onChange(e);
            onChange === null || onChange === void 0 ? void 0 : onChange(e);
        },
        onBlur: (e)=>{
            input.onBlur(e);
            onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
        },
        onFocus: (e)=>{
            input.onFocus(e);
            onFocus === null || onFocus === void 0 ? void 0 : onFocus();
        },
        ref: inputRef
    });
};
/* harmony default export */ var find_a_car_text_field = (FindACarTextField);

;// CONCATENATED MODULE: ../../../libs/consumer-lending/feature-car-finance/src/lib/components/find-a-car/find-a-car.tsx
/* eslint-disable @typescript-eslint/no-explicit-any */ 














var FinanceType;
(function(FinanceType) {
    FinanceType["PCP"] = "PCP";
    FinanceType["HP"] = "HP";
})(FinanceType || (FinanceType = {}));
const calculateHpCarPrice = (monthlyBudget)=>{
    const years = 4;
    const flatInterestRate = 5.14;
    const x = monthlyBudget / (1 + years * flatInterestRate / 100);
    return x * (years * 12) + 2000;
};
function FindACar({ i18n  }) {
    const baseCtaUrl = "/used-cars";
    const [formData, setFormData] = (0,react.useState)({
        budgetType: FinanceType.PCP
    });
    const [ctaText, setCtaText] = (0,react.useState)({
        aria: "",
        short: "",
        long: ""
    });
    const [ctaUrl, setCtaUrl] = (0,react.useState)(baseCtaUrl);
    const [budgetDescription, setBudgetDescription] = (0,react.useState)([]);
    const { trackEvent  } = (0,analytics_src/* useAnalytics */.z$)();
    const budgetTypeOptionsLabel = (index, checked)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
            size: "s",
            fontWeight: checked ? "bold" : "medium",
            children: i18n.searchSection[index].label
        });
    const budgetTypeOptionsSubLabel = (index, checked)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
            size: "s",
            className: classnames_default()((find_a_car_module_default()).budgetTypeText, {
                [(find_a_car_module_default()).budgetTypeHidden]: !checked
            }),
            children: i18n.searchSection[index].sublabel
        });
    const budgetTypeOptions = Object.entries(FinanceType).map(([key, value])=>{
        const index = key;
        return {
            value: value,
            label: (checked)=>budgetTypeOptionsLabel(index, checked),
            subLabel: (checked)=>budgetTypeOptionsSubLabel(index, checked)
        };
    });
    const onSubmit = (values)=>{
        if (!values.budgetType) {
            return;
        }
        trackFormEvents(values);
    };
    const trackFormEvents = (values)=>{
        const trackValue = (()=>{
            const budget = Number.parseInt(values.budget || "", 10);
            if (values.budget === "" || values.budget === undefined) {
                return "-";
            }
            if (!Number.isNaN(budget)) {
                return `${budget / 100}`;
            }
            return "";
        })();
        trackEvent(financeBudgetCalculator(values.budgetType, trackValue));
    };
    (0,react.useEffect)(()=>{
        const budget = Number.parseInt(formData.budget || "", 10);
        if (formData.budget && !Number.isNaN(budget)) {
            const budgetInPounds = budget / 100;
            const isPCP = formData.budgetType === FinanceType.PCP;
            const hpCarPrice = Math.round(calculateHpCarPrice(budgetInPounds));
            const hpCarPriceFormatted = (0,util_src/* currencyValueFormatter */.DY)(hpCarPrice);
            const hpBudgetDescription = (0,util_src/* interpolateI18n */.uR)(i18n.inputSection.hpBudgetDescription, {
                calculateHpCarPrice: hpCarPriceFormatted,
                budget: (0,util_src/* currencyValueFormatter */.DY)(budgetInPounds)
            }, {
                b: (v)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                        element: "span",
                        fontWeight: "bold",
                        children: v
                    }, v)
            });
            const message = getActiveCtaText(i18n.cta.active.message, isPCP ? budgetInPounds : hpCarPrice);
            if (!isPCP) {
                setBudgetDescription(hpBudgetDescription);
                setCtaUrl(getFiltredUrl(baseCtaUrl, hpCarPrice, false));
            } else {
                setCtaUrl(getFiltredUrl(baseCtaUrl, budgetInPounds, true));
            }
            setCtaText({
                aria: `${message}${isPCP ? i18n.cta.active.suffix.aria : ""}`,
                short: `${message}${isPCP ? i18n.cta.active.suffix.short : ""}`,
                long: `${message}${isPCP ? i18n.cta.active.suffix.long : ""}`
            });
        } else {
            setCtaText({
                aria: i18n.cta.default,
                short: i18n.cta.default,
                long: i18n.cta.default
            });
            setCtaUrl(baseCtaUrl);
            setBudgetDescription([]);
        }
    }, [
        formData.budget,
        formData.budgetType
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* Wrapper */.im, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
            className: (find_a_car_module_default()).findACar,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                    element: "h2",
                    className: (find_a_car_module_default()).financeFeatureTitle,
                    fontSize: index_esm/* TextFontSizes.4xl */.Xo["4xl"],
                    fontWeight: index_esm/* TextFontWeights.bold */.Ax.bold,
                    lineHeight: index_esm/* TextLineHeights.display */.ET.display,
                    children: i18n.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
                    className: (find_a_car_module_default()).financeFeaturePicture,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                            srcSet: `${lady_with_car_keys_small.src} 1x, ${lady_with_car_keys_small.src} 2x`,
                            type: "image/png",
                            media: "(max-width: 767px)"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: (find_a_car_module_default()).financeFeatureImage,
                            srcSet: `${lady_with_car_keys_large.src} 1x, ${lady_with_car_keys_large.src} 2x`,
                            alt: i18n.alt,
                            loading: "lazy"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Form */.l0, {
                    initialValues: formData,
                    onSubmit: onSubmit,
                    render: ({ handleSubmit , values  })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                            className: (find_a_car_module_default()).financeFeatureForm,
                            onSubmit: handleSubmit,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                    name: "budgetType",
                                    component: find_a_car_radio_field,
                                    options: budgetTypeOptions,
                                    label: i18n.searchSection.subtitle,
                                    classNames: {
                                        container: (find_a_car_module_default()).budgetTypeOptionsContainer,
                                        legend: (find_a_car_module_default()).budgetTypeOptionLegend,
                                        radio: {
                                            container: (find_a_car_module_default()).budgetTypeOptionRadioContainer,
                                            label: (find_a_car_module_default()).budgetTypeOptionRadioLabel
                                        }
                                    },
                                    onChange: (evt)=>{
                                        setFormData({
                                            ...formData,
                                            budgetType: evt.target.value
                                        });
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                    id: "budgetInput",
                                    name: "budget",
                                    component: find_a_car_text_field,
                                    label: i18n.inputSection.subtitle,
                                    placeholder: `£`,
                                    format: formatToPounds,
                                    inputMode: "numeric",
                                    fullWidth: true,
                                    classNames: {
                                        container: (find_a_car_module_default()).searchInputContainer,
                                        label: {
                                            label: (find_a_car_module_default()).searchInputLabel
                                        }
                                    },
                                    maxLength: 5,
                                    onChange: (evt)=>{
                                        setFormData({
                                            ...formData,
                                            budget: convertToPence(evt.target.value)
                                        });
                                    }
                                }),
                                budgetDescription.length > 0 && formData.budgetType === FinanceType.HP && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                    fontWeight: "book",
                                    fontSize: "m",
                                    className: (find_a_car_module_default()).budgetDescription,
                                    children: budgetDescription
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                    className: (find_a_car_module_default()).searchDescription,
                                    fontWeight: "book",
                                    fontSize: "xs",
                                    children: i18n.inputSection.description
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Primary */.sq, {
                                    isFullWidth: true,
                                    element: "a",
                                    href: ctaUrl,
                                    "aria-label": ctaText.aria,
                                    onClick: ()=>trackFormEvents(values),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            "data-testid": "ctaTextShort",
                                            className: (find_a_car_module_default()).searchCtaShort,
                                            children: `${ctaText.short}`
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            "data-testid": "ctaTextLong",
                                            className: (find_a_car_module_default()).searchCtaLong,
                                            children: `${ctaText.long}`
                                        })
                                    ]
                                })
                            ]
                        })
                })
            ]
        })
    });
}
/* harmony default export */ var find_a_car = (FindACar);

// EXTERNAL MODULE: ../../../libs/consumer-lending/feature-car-finance/src/lib/components/how-it-works/how-it-works.module.css
var how_it_works_module = __webpack_require__(31701);
var how_it_works_module_default = /*#__PURE__*/__webpack_require__.n(how_it_works_module);
;// CONCATENATED MODULE: ../../../libs/consumer-lending/feature-car-finance/src/lib/components/how-it-works/how-it-works-step.tsx



const HowItWorksStep = ({ i18n , Image , children  })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (how_it_works_module_default()).howItWorksImage,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                    "aria-hidden": "true"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                className: (how_it_works_module_default()).howItWorksTitle,
                element: "h3",
                fontSize: index_esm/* TextFontSizes.l */.Xo.l,
                fontWeight: index_esm/* TextFontWeights.bold */.Ax.bold,
                lineHeight: index_esm/* TextLineHeights.display */.ET.display,
                children: i18n.title
            }),
            children ? children : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                fontSize: index_esm/* TextFontSizes.m */.Xo.m,
                fontWeight: index_esm/* TextFontWeights.book */.Ax.book,
                children: i18n.text
            })
        ]
    });
/* harmony default export */ var how_it_works_step = (HowItWorksStep);

;// CONCATENATED MODULE: ../../../libs/consumer-lending/feature-car-finance/src/lib/components/how-it-works/assets/finance-offer.svg
var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const SvgFinanceOffer = props => /*#__PURE__*/react.createElement("svg", _extends({
  width: 60,
  height: 57,
  viewBox: "0 0 60 57",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M45 2.692c-6.797 0-12.308 5.51-12.308 12.308 0 6.797 5.51 12.308 12.308 12.308 6.797 0 12.308-5.51 12.308-12.308 0-6.797-5.51-12.308-12.308-12.308ZM30 15c0-8.284 6.716-15 15-15 8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15Zm21.13-4.62c.533.518.546 1.37.028 1.904l-7.843 8.077a1.346 1.346 0 0 1-1.987-.062l-3.312-3.863a1.346 1.346 0 0 1 2.044-1.752l2.352 2.743 6.815-7.019a1.346 1.346 0 0 1 1.903-.028ZM4.035 18.853c-.8.853-1.343 2.18-1.343 4.032V49.23c0 1.435.477 2.685 1.281 3.561.79.862 1.962 1.439 3.527 1.439h40.962c1.883 0 4.038-1.441 4.038-4.231V31.538a1.346 1.346 0 1 1 2.692 0V50c0 4.518-3.614 6.923-6.73 6.923H7.5c-2.282 0-4.186-.866-5.512-2.311C.677 53.18 0 51.257 0 49.23V22.885c0-2.38.707-4.418 2.07-5.873 1.372-1.463 3.285-2.204 5.43-2.204h19.23a1.346 1.346 0 0 1 0 2.692H7.5c-1.51 0-2.673.508-3.465 1.353Zm12.119 7.685a4.23 4.23 0 1 0 0 8.462 4.23 4.23 0 0 0 0-8.462ZM9.23 30.77a6.923 6.923 0 1 1 10.952 5.63c1.085.869 1.909 2.042 2.515 3.23 1.207 2.364 1.76 5.144 1.913 6.991a1.346 1.346 0 0 1-1.342 1.457H9.04a1.346 1.346 0 0 1-1.34-1.479c.183-1.847.782-4.624 2.026-6.985.61-1.156 1.424-2.298 2.481-3.156a6.915 6.915 0 0 1-2.975-5.688Zm22.115 3.846c0-.743.603-1.346 1.346-1.346h11.154a1.346 1.346 0 0 1 0 2.693H32.692a1.346 1.346 0 0 1-1.346-1.347Zm-20.75 10.77h11.142c-.247-1.427-.707-3.1-1.438-4.532-1.013-1.985-2.343-3.16-4.06-3.16-1.725 0-3.084 1.184-4.133 3.175-.753 1.428-1.24 3.093-1.511 4.517Zm20.75-5.77c0-.743.603-1.346 1.346-1.346h11.154a1.346 1.346 0 0 1 0 2.693H32.692a1.346 1.346 0 0 1-1.346-1.347Zm0 5c0-.743.603-1.346 1.346-1.346h11.154a1.346 1.346 0 0 1 0 2.693H32.692a1.346 1.346 0 0 1-1.346-1.347Z",
  fill: "url(#a)"
})), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("linearGradient", {
  id: "a",
  x1: 0.192,
  y1: 4.423,
  x2: 56.538,
  y2: 56.731,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/react.createElement("stop", {
  stopColor: "#311C77"
}), /*#__PURE__*/react.createElement("stop", {
  offset: 1,
  stopColor: "#8C32BE"
})))));
/* harmony default export */ var finance_offer = (SvgFinanceOffer);
;// CONCATENATED MODULE: ../../../libs/consumer-lending/feature-car-finance/src/lib/components/how-it-works/assets/finance-apply.svg
var finance_apply_path, finance_apply_defs;
function finance_apply_extends() { finance_apply_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return finance_apply_extends.apply(this, arguments); }

const SvgFinanceApply = props => /*#__PURE__*/react.createElement("svg", finance_apply_extends({
  width: 52,
  height: 60,
  viewBox: "0 0 52 60",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), finance_apply_path || (finance_apply_path = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.52.125a1.278 1.278 0 0 1 1.703.601l2.007 4.195a1.276 1.276 0 1 1-2.305 1.101l-2.007-4.194A1.276 1.276 0 0 1 19.52.125Zm10.042 0c.636.304.905 1.067.6 1.703l-2.006 4.194a1.277 1.277 0 0 1-2.304-1.101L27.858.726a1.277 1.277 0 0 1 1.704-.6ZM13.85 4.595a1.278 1.278 0 0 1 1.805-.052l3.284 3.1A1.276 1.276 0 1 1 17.186 9.5l-3.284-3.1a1.276 1.276 0 0 1-.051-1.805Zm21.38 0c.484.512.46 1.32-.052 1.804l-3.284 3.1a1.278 1.278 0 0 1-1.754-1.855l3.284-3.1a1.278 1.278 0 0 1 1.805.05Zm-12.237 6.801c-.452.716-.734 1.807-.734 3.125v23.575c0 1.096-.298 2.047-.86 2.803-.558.75-1.32 1.23-2.125 1.484-1.566.493-3.409.17-4.721-.809l-.007-.005-.004-.003c-1.97-1.47-3.957-2.953-6.438-4.927-1.103-.879-2.211-1.338-3.093-1.382-.796-.04-1.446.244-1.928 1.042-.594.985-.607 1.589-.43 2.151.223.712.795 1.509 1.813 2.775.894 1.112 3.006 2.99 5.57 5.168.83.705 1.7 1.436 2.574 2.17 1.763 1.48 3.541 2.973 5.034 4.293 2.16 1.91 3.885 3.037 5.55 3.7 1.652.657 3.33.89 5.45.89H41.6c1.484 0 3.48-.518 5.077-1.76 1.548-1.203 2.769-3.116 2.769-6.081v-18.42c0-1.67-.47-2.408-.866-2.756-.428-.376-1.03-.526-1.689-.526-.5 0-1.073.196-1.523.66-.436.45-.849 1.25-.849 2.623v6.565a1.277 1.277 0 0 1-2.554 0V27.72c0-1.449-.448-2.227-.897-2.649-.475-.446-1.1-.634-1.657-.634a2 2 0 0 0-1.287.513c-.407.37-.903 1.134-.903 2.77v7.294a1.277 1.277 0 0 1-2.554 0V28.45c0-1.882-.105-3.388-.499-4.403-.186-.479-.407-.769-.643-.944-.226-.167-.566-.306-1.137-.306-1.15 0-1.656.436-1.957.96-.368.638-.508 1.562-.508 2.56v6.376a1.277 1.277 0 0 1-2.554 0V14.521c0-1.559-.34-2.608-.8-3.233-.425-.575-1.02-.893-1.872-.893-.733 0-1.28.333-1.703 1.001Zm6.929 9.413v-6.288c0-1.878-.401-3.531-1.298-4.747-.933-1.267-2.312-1.932-3.928-1.932-1.736 0-3.045.895-3.863 2.192-.788 1.248-1.128 2.859-1.128 4.487v23.575c0 .623-.164 1.022-.356 1.28-.195.262-.478.457-.843.572-.773.243-1.762.075-2.425-.42l-.006-.005c-1.973-1.471-3.931-2.933-6.38-4.882-1.364-1.085-2.97-1.855-4.557-1.933-1.672-.084-3.243.616-4.242 2.273-.887 1.47-1.12 2.831-.68 4.234.393 1.252 1.303 2.42 2.259 3.61 1.08 1.343 3.41 3.393 5.907 5.514.856.727 1.74 1.47 2.622 2.21 1.747 1.466 3.479 2.92 4.948 4.22 2.283 2.018 4.26 3.347 6.297 4.158C24.3 59.743 26.324 60 28.646 60H41.6c1.983 0 4.548-.667 6.645-2.298C50.392 56.033 52 53.387 52 49.605v-18.42c0-2.159-.625-3.7-1.734-4.674-1.077-.947-2.392-1.161-3.375-1.161a4.67 4.67 0 0 0-2.527.753c-.252-1.223-.796-2.187-1.547-2.892-1.03-.967-2.321-1.326-3.406-1.326-.767 0-1.92.24-2.917 1.1-.306-.735-.761-1.423-1.446-1.932-.74-.549-1.64-.81-2.66-.81-.97 0-1.79.205-2.465.566Z",
  fill: "url(#a)"
})), finance_apply_defs || (finance_apply_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("linearGradient", {
  id: "a",
  x1: 5.109,
  y1: 7.113,
  x2: 47.962,
  y2: 58.743,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/react.createElement("stop", {
  stopColor: "#311C77"
}), /*#__PURE__*/react.createElement("stop", {
  offset: 1,
  stopColor: "#8C32BE"
})))));
/* harmony default export */ var finance_apply = (SvgFinanceApply);
;// CONCATENATED MODULE: ../../../libs/consumer-lending/feature-car-finance/src/lib/components/how-it-works/assets/finance-decision.svg
var finance_decision_path, finance_decision_defs;
function finance_decision_extends() { finance_decision_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return finance_decision_extends.apply(this, arguments); }

const SvgFinanceDecision = props => /*#__PURE__*/react.createElement("svg", finance_decision_extends({
  width: 54,
  height: 64,
  viewBox: "0 0 54 64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), finance_decision_path || (finance_decision_path = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.29 3.355c-6.84 0-12.386 5.546-12.386 12.387S22.45 28.129 29.29 28.129c6.84 0 12.387-5.546 12.387-12.387S36.132 3.355 29.29 3.355ZM14.195 15.742C14.194 7.404 20.953.645 29.29.645c8.337 0 15.096 6.76 15.096 15.097 0 7.07-4.858 13.004-11.419 14.646v.507c.7.1 1.518.34 2.258.818 1.111.715 2 1.946 2 3.77 0 .949-.23 1.742-.573 2.393.928.12 1.763.399 2.433.908 1.01.768 1.43 1.887 1.43 3.087 0 1.226-.273 2.456-1.247 3.332.51.621.86 1.443.86 2.474 0 1.289-.394 2.486-1.558 3.245-.096.063-.195.12-.297.175.432.64.694 1.436.694 2.387 0 1.674-.816 2.832-1.957 3.494a5.194 5.194 0 0 1-1.21.502c.179.444.264.925.264 1.423 0 .91-.164 2.113-1.078 3.067-.918.957-2.321 1.385-4.148 1.385H8.387c-2.699 0-4.721-.821-6.038-2.362-1.282-1.501-1.703-3.466-1.703-5.38V45.355c0-2.465.855-4.267 2.215-5.432 1.319-1.13 2.965-1.536 4.365-1.536l.487.001c1.019.005 1.84.008 2.634-.181.824-.198 1.616-.612 2.386-1.614.385-.5.718-1.006 1.07-1.54l.171-.26c.402-.606.844-1.258 1.367-1.838 1.12-1.24 2.585-2.116 4.853-2.116h4.645v-.667c-6.165-1.9-10.645-7.642-10.645-14.43Zm13.355 14.997v7.067h2.71v-6.998a15.357 15.357 0 0 1-2.71-.069Zm5.581 9.777H27.55c-1.243 0-2.322-.43-3.137-.92-.809-.485-1.434-1.076-1.792-1.524a1.355 1.355 0 0 1 2.116-1.693c.027.035.062.075.103.12v-2.95h-4.645c-1.41 0-2.17.479-2.841 1.222-.372.412-.716.91-1.119 1.518l-.162.245c-.348.53-.741 1.126-1.191 1.711-1.165 1.515-2.503 2.262-3.904 2.597-1.138.272-2.32.264-3.313.257l-.438-.002c-.923 0-1.889.272-2.602.883-.673.577-1.269 1.581-1.269 3.375v10.258c0 1.57.353 2.798 1.055 3.62.667.781 1.838 1.412 3.977 1.412H30.84c1.464 0 1.996-.347 2.191-.55.199-.208.325-.553.325-1.192 0-.386-.116-.572-.335-.725-.303-.21-.949-.436-2.18-.436h-4.453a1.355 1.355 0 0 1 0-2.71h7.355c.76 0 1.454-.133 1.909-.397.359-.209.607-.503.607-1.151 0-.665-.267-1.026-.662-1.281-.463-.3-1.15-.461-1.854-.461h-5.806a1.355 1.355 0 0 1 0-2.71h6.774c1.418 0 2.083-.186 2.381-.38.143-.093.329-.25.329-.975 0-.496-.21-.787-.514-1.001-.36-.254-.809-.353-1.035-.353-.032 0-.065-.002-.097-.004-.096.002-.193.004-.29.004h-5.613a1.355 1.355 0 0 1 0-2.71h5.613c1.251 0 1.757-.235 1.963-.415.157-.137.36-.44.36-1.327 0-.542-.161-.778-.36-.93-.268-.203-.841-.425-1.963-.425H33.13Zm-.162-2.737a3.2 3.2 0 0 0 .78-.518c.407-.372.769-.915.769-1.777 0-.808-.338-1.222-.758-1.493a2.767 2.767 0 0 0-.79-.336v4.124Zm2.492-26.687c.537.522.55 1.38.029 1.916l-7.894 8.13a1.355 1.355 0 0 1-2-.063l-3.333-3.887a1.355 1.355 0 0 1 2.057-1.764l2.367 2.76 6.858-7.063a1.355 1.355 0 0 1 1.916-.029ZM52.99 35a1.355 1.355 0 0 1-.496 1.85l-6.672 3.852a1.355 1.355 0 1 1-1.355-2.346l6.672-3.852a1.355 1.355 0 0 1 1.85.496Zm-8.602 11.516c0-.748.607-1.355 1.355-1.355h6.58a1.355 1.355 0 1 1 0 2.71h-6.58a1.355 1.355 0 0 1-1.355-1.355Zm-.73 6.406a1.355 1.355 0 0 1 1.85-.495l6.671 3.851a1.355 1.355 0 1 1-1.354 2.347l-6.672-3.852a1.355 1.355 0 0 1-.496-1.85Z",
  fill: "url(#a)"
})), finance_decision_defs || (finance_decision_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("linearGradient", {
  id: "a",
  x1: 0.839,
  y1: 2.774,
  x2: 53.871,
  y2: 63.161,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/react.createElement("stop", {
  stopColor: "#311C77"
}), /*#__PURE__*/react.createElement("stop", {
  offset: 1,
  stopColor: "#8C32BE"
})))));
/* harmony default export */ var finance_decision = (SvgFinanceDecision);
;// CONCATENATED MODULE: ../../../libs/consumer-lending/feature-car-finance/src/lib/components/how-it-works/assets/finance-calculator.svg
var finance_calculator_path, _path2, _path3, _path4, _path5, _path6, finance_calculator_defs;
function finance_calculator_extends() { finance_calculator_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return finance_calculator_extends.apply(this, arguments); }

const SvgFinanceCalculator = props => /*#__PURE__*/react.createElement("svg", finance_calculator_extends({
  viewBox: "0 0 47 47",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), finance_calculator_path || (finance_calculator_path = /*#__PURE__*/react.createElement("path", {
  d: "M46.11 23.717V41.89c0 2.294-1.457 4.097-3.658 4.528-.312.058-.629.085-.946.082H13.374A12.845 12.845 0 0 1 .705 35.996c-1.256-6.725 3.117-13.341 9.803-14.828.263-.06.347-.15.346-.425-.01-5.071-.01-10.143 0-15.216 0-1.946 1.025-3.568 2.751-4.24a4.968 4.968 0 0 1 1.754-.35A6539.9 6539.9 0 0 1 41.585.923c2.572 0 4.524 1.984 4.527 4.588.003 6.068.002 12.137-.003 18.206Zm-21.387 4.075c.037-.122.059-.183.075-.246.332-1.274 1.34-2.06 2.654-2.066.735 0 1.468-.014 2.202 0 1.254.03 2.388.975 2.51 2.219.098.99.102 1.988.011 2.98a2.497 2.497 0 0 1-2.389 2.267c-1.212.046-2.451.227-3.68-.262v2.658c.394-.085.81-.224 1.226-.246.765-.041 1.533-.023 2.3-.01 1.265.023 2.412.975 2.538 2.229.101.969.107 1.945.018 2.915-.131 1.411-1.276 2.347-2.699 2.352h-2.103a2.665 2.665 0 0 1-2.649-2.56v-.323a17.64 17.64 0 0 1-2.091 2.78 17.828 17.828 0 0 1-2.608 2.205h21.52c1.577 0 2.724-1.129 2.725-2.704V5.435c0-1.56-1.146-2.687-2.702-2.687H15.42c-1.633 0-2.76 1.13-2.76 2.769V20.83l2.457.101c0-.789-.007-1.554 0-2.32.021-1.593 1.157-2.725 2.745-2.737.756 0 1.512-.02 2.267.013 1.251.055 2.344 1.043 2.446 2.287.07.95.07 1.904 0 2.853-.064.956-.63 1.631-1.47 2.075-.09.048-.184.092-.307.153a13.145 13.145 0 0 1 3.924 4.54v-.003Zm-.387 5.905a10.995 10.995 0 0 0-11.125-11.02c-6.098.03-10.992 5.112-10.896 11.184.093 5.944 5.012 10.89 11.16 10.838 5.937-.057 10.877-5.03 10.861-11.002Zm6.064 5.158v-1.051c0-.534-.328-.89-.869-.9a45.812 45.812 0 0 0-2.165.011.825.825 0 0 0-.83.841 51.637 51.637 0 0 0 0 2.167c.009.443.325.816.734.83.79.028 1.578.035 2.367.008.464-.014.763-.385.769-.857-.003-.355-.006-.704-.006-1.055v.006ZM18.865 21.548h1.083a.827.827 0 0 0 .853-.847c.01-.711.008-1.422 0-2.133a.846.846 0 0 0-.83-.883c-.733-.02-1.466-.02-2.198 0a.85.85 0 0 0-.843.875 68.05 68.05 0 0 0 0 2.133.846.846 0 0 0 .883.856c.351.001.702-.001 1.052-.001Zm11.535 7.68V28.21c0-.54-.32-.91-.849-.92a41.063 41.063 0 0 0-2.166.009.838.838 0 0 0-.85.861 48.025 48.025 0 0 0 0 2.134.852.852 0 0 0 .881.866 60.94 60.94 0 0 0 2.134 0c.52-.01.848-.362.852-.88.001-.35-.002-.702-.002-1.053Z",
  fill: "url(#a)"
})), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
  d: "M28.45 13.773H16.29c-.884 0-1.183-.297-1.183-1.183V5.985c0-.825.31-1.135 1.126-1.135H40.91a.887.887 0 0 1 .91.814c.01.109.012.218.008.327 0 2.147-.027 4.295.012 6.441.018 1.065-.417 1.364-1.37 1.352-2.541-.03-5.082-.01-7.625-.01H28.45Zm-11.511-1.84h23.05V6.659H16.94v5.274Z",
  fill: "url(#b)"
})), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
  d: "M41.838 34.026v5.685c0 1.748-1.127 2.873-2.88 2.873h-2.004a2.642 2.642 0 0 1-2.612-2.598c-.016-3.965-.016-7.93 0-11.896a2.63 2.63 0 0 1 2.601-2.602c.735-.015 1.469-.01 2.202 0a2.662 2.662 0 0 1 2.689 2.688c.014 1.95.004 3.9.004 5.85Zm-1.821.027V28.27c0-.637-.337-.98-.966-.986a94.941 94.941 0 0 0-1.94 0c-.618 0-.972.363-.972.99v11.501c0 .658.342.993.992 1h1.808c.778 0 1.078-.3 1.08-1.07l-.002-5.65Z",
  fill: "url(#c)"
})), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
  d: "M24.727 19.606v-.985c.011-1.591 1.14-2.73 2.726-2.746a98.73 98.73 0 0 1 2.036 0c1.446.014 2.562.95 2.702 2.385.088.915.088 1.837 0 2.753a2.51 2.51 0 0 1-2.336 2.324c-.959.082-1.923.075-2.88-.021-1.238-.122-2.176-1.217-2.235-2.461-.019-.415 0-.832 0-1.249h-.013Zm3.718 1.942h1.052c.563 0 .9-.335.903-.89V18.59c0-.532-.338-.9-.865-.908a57.922 57.922 0 0 0-2.133 0 .838.838 0 0 0-.863.85c-.017.72-.02 1.446 0 2.165.012.51.383.843.894.847.334.006.673.004 1.012.004Z",
  fill: "url(#d)"
})), _path5 || (_path5 = /*#__PURE__*/react.createElement("path", {
  d: "M38.092 15.874h1.052c1.401.025 2.525.977 2.657 2.366.083.917.083 1.838 0 2.754a2.521 2.521 0 0 1-2.322 2.335c-.959.086-1.924.082-2.883-.013-1.284-.131-2.234-1.254-2.26-2.541a62.938 62.938 0 0 1 0-2.3 2.644 2.644 0 0 1 2.54-2.596c.405-.018.81 0 1.215 0l.001-.005Zm-.038 5.674h1.052c.544 0 .898-.325.907-.86.012-.71.01-1.421 0-2.132a.844.844 0 0 0-.84-.873 45.37 45.37 0 0 0-2.198 0 .826.826 0 0 0-.823.82 38.348 38.348 0 0 0-.008 2.198c.013.517.382.842.894.846.338.003.681 0 1.016 0Z",
  fill: "url(#e)"
})), _path6 || (_path6 = /*#__PURE__*/react.createElement("path", {
  d: "M8.786 31.557c.087.346.176.691.275 1.078-.3 0-.55-.005-.805-.01-.573.02-.949.387-.94.92.007.51.395.874.944.882.353.01.704-.014 1.052.01a.355.355 0 0 1 .254.2c.106.343.194.692.263 1.045a2.84 2.84 0 0 1-1.277 2.946c-.206.123-.404.26-.591.411a1.121 1.121 0 0 0-.293.386.874.874 0 0 0 .252 1.012.894.894 0 0 0 1.042.09c.246-.141.463-.332.726-.444 1.042-.45 2.032-.33 2.94.352 1.783 1.347 4.013 1.406 5.734.132.198-.148.352-.348.447-.577a.848.848 0 0 0-.351-.98c-.34-.23-.723-.21-1.1.061-1.058.76-2.329.85-3.313.147-.82-.59-1.674-1.063-2.63-1.17.098-.608.257-1.19.263-1.791.007-.601-.135-1.205-.215-1.824h.657c1.292 0 2.586.007 3.878 0a.891.891 0 0 0 .903-.752.881.881 0 0 0-.555-.974 1.597 1.597 0 0 0-.514-.068c-1.534-.007-3.067-.01-4.6 0-.225.001-.33-.057-.38-.29-.095-.46-.235-.91-.346-1.366-.368-1.516.545-3.087 2.011-3.46 1.801-.46 3.464.799 3.595 2.731.042.604.415.98.942.955.527-.025.873-.434.855-1.038a4.679 4.679 0 0 0-5.94-4.37c-2.432.682-3.824 3.212-3.183 5.756Z",
  fill: "url(#f)"
})), finance_calculator_defs || (finance_calculator_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("linearGradient", {
  id: "a",
  x1: 47.166,
  y1: 37.813,
  x2: 13.257,
  y2: 24.13,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/react.createElement("stop", {
  offset: 0,
  stopColor: "#311C77"
}), /*#__PURE__*/react.createElement("stop", {
  offset: 1,
  stopColor: "#8C32BE"
})), /*#__PURE__*/react.createElement("linearGradient", {
  id: "b",
  x1: 41.867,
  y1: 12.735,
  x2: 19.744,
  y2: 7.9,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/react.createElement("stop", {
  offset: 0,
  stopColor: "#311C77"
}), /*#__PURE__*/react.createElement("stop", {
  offset: 1,
  stopColor: "#8C32BE"
})), /*#__PURE__*/react.createElement("linearGradient", {
  id: "c",
  x1: 41.869,
  y1: 34.988,
  x2: 29.626,
  y2: 33.703,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/react.createElement("stop", {
  offset: 0,
  stopColor: "#311C77"
}), /*#__PURE__*/react.createElement("stop", {
  offset: 1,
  stopColor: "#8C32BE"
})), /*#__PURE__*/react.createElement("linearGradient", {
  id: "d",
  x1: 42.221,
  y1: 25.098,
  x2: 19.166,
  y2: 23.519,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/react.createElement("stop", {
  offset: 0,
  stopColor: "#311C77"
}), /*#__PURE__*/react.createElement("stop", {
  offset: 1,
  stopColor: "#8C32BE"
})), /*#__PURE__*/react.createElement("linearGradient", {
  id: "e",
  x1: 40.808,
  y1: 21.565,
  x2: 31.152,
  y2: 18.651,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/react.createElement("stop", {
  offset: 0,
  stopColor: "#311C77"
}), /*#__PURE__*/react.createElement("stop", {
  offset: 1,
  stopColor: "#8C32BE"
})), /*#__PURE__*/react.createElement("linearGradient", {
  id: "f",
  x1: 27.385,
  y1: 40.286,
  x2: 12.746,
  y2: 36.553,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/react.createElement("stop", {
  offset: 0,
  stopColor: "#311C77"
}), /*#__PURE__*/react.createElement("stop", {
  offset: 1,
  stopColor: "#8C32BE"
})))));
/* harmony default export */ var finance_calculator = (SvgFinanceCalculator);
// EXTERNAL MODULE: ../../../node_modules/next/link.js
var next_link = __webpack_require__(89218);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ../../../libs/consumer-lending/feature-car-finance/src/lib/components/how-it-works/how-it-works.tsx











function renderLink(text, path, classNames) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: path,
        passHref: true,
        legacyBehavior: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: (how_it_works_module_default()).linkText,
            target: "_blank",
            rel: "noreferrer noopener",
            href: path,
            children: text
        })
    });
}
function HowItWorks({ i18n , className  }) {
    const [getAQuoteBeforeLink, getAQuoteAfterLink] = i18n.steps[0].splitText ?? [];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
        className: classnames_default()((how_it_works_module_default()).howItWorks, className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(src/* Wrapper */.im, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                    element: "h2",
                    fontSize: index_esm/* TextFontSizes.4xl */.Xo["4xl"],
                    fontWeight: index_esm/* TextFontWeights.bold */.Ax.bold,
                    lineHeight: index_esm/* TextLineHeights.display */.ET.display,
                    className: (how_it_works_module_default()).howItWorksMainTitle,
                    children: i18n.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                    fontSize: index_esm/* TextFontSizes.m */.Xo.m,
                    fontWeight: index_esm/* TextFontWeights.book */.Ax.book,
                    children: i18n.text
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                    className: (how_it_works_module_default()).howItWorksSteps,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(how_it_works_step, {
                            i18n: i18n.steps[0],
                            Image: finance_calculator,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                fontSize: index_esm/* TextFontSizes.m */.Xo.m,
                                fontWeight: index_esm/* TextFontWeights.book */.Ax.book,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        "data-testid": "get-a-quote-before-text",
                                        children: getAQuoteBeforeLink
                                    }),
                                    renderLink("HP", "/car-finance/hire-purchase"),
                                    " or",
                                    " ",
                                    renderLink("PCP", "/car-finance/personal-contract-purchase"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        "data-testid": "get-a-quote-after-text",
                                        children: getAQuoteAfterLink
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(how_it_works_step, {
                            i18n: i18n.steps[1],
                            Image: finance_apply
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(how_it_works_step, {
                            i18n: i18n.steps[2],
                            Image: finance_decision
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(how_it_works_step, {
                            i18n: i18n.steps[3],
                            Image: finance_offer
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var how_it_works = (HowItWorks);

// EXTERNAL MODULE: ../../../libs/consumer-lending/feature-car-finance/src/lib/components/ready-to-get-car-finance/ready-to-get-car-finance.module.css
var ready_to_get_car_finance_module = __webpack_require__(69314);
var ready_to_get_car_finance_module_default = /*#__PURE__*/__webpack_require__.n(ready_to_get_car_finance_module);
;// CONCATENATED MODULE: ../../../libs/consumer-lending/feature-car-finance/src/lib/components/ready-to-get-car-finance/ready-to-get-car-finance.tsx







function ReadyToGetCarFinance({ i18n , className  }) {
    const { trackEvent  } = (0,analytics_src/* useAnalytics */.z$)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
        className: classnames_default()((ready_to_get_car_finance_module_default()).readyToGetCarFinance, className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(src/* Wrapper */.im, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                    element: "h2",
                    fontSize: index_esm/* TextFontSizes.4xl */.Xo["4xl"],
                    fontWeight: index_esm/* TextFontWeights.bold */.Ax.bold,
                    lineHeight: index_esm/* TextLineHeights.display */.ET.display,
                    className: (ready_to_get_car_finance_module_default()).readyToGetCarFinanceMainTitle,
                    children: i18n.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                    fontSize: index_esm/* TextFontSizes.s */.Xo.s,
                    fontWeight: index_esm/* TextFontWeights.book */.Ax.book,
                    children: i18n.text
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ready_to_get_car_finance_module_default()).readyToGetCarFinanceButton,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Primary */.sq, {
                        "data-testid": "search-all-cars-button",
                        element: "a",
                        href: "/used-cars",
                        onClick: ()=>trackEvent(searchAllCarsClick()),
                        children: "Search all cars"
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var ready_to_get_car_finance = (ReadyToGetCarFinance);

;// CONCATENATED MODULE: ../../../libs/consumer-lending/feature-car-finance/src/lib/components/trustpilot-score/stars/assets/stars-4.5.svg
var _style, stars_4_5_path, stars_4_5_path2, stars_4_5_path3, stars_4_5_path4, stars_4_5_path5;
function stars_4_5_extends() { stars_4_5_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return stars_4_5_extends.apply(this, arguments); }

const SvgStars45 = props => /*#__PURE__*/react.createElement("svg", stars_4_5_extends({
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  x: 0,
  y: 0,
  viewBox: "0 0 512 96",
  style: {
    enableBackground: "new 0 0 512 96"
  },
  xmlSpace: "preserve"
}, props), _style || (_style = /*#__PURE__*/react.createElement("style", null, ".st0{fill:#00b67a}.st2{fill:#fff}")), /*#__PURE__*/react.createElement("g", {
  id: "Trustpilot_ratings_4halfstar-RGB"
}, /*#__PURE__*/react.createElement("g", null, stars_4_5_path || (stars_4_5_path = /*#__PURE__*/react.createElement("path", {
  id: "Rectangle-path",
  className: "st0",
  d: "M0 0h96v96H0z"
})), stars_4_5_path2 || (stars_4_5_path2 = /*#__PURE__*/react.createElement("path", {
  className: "st0",
  d: "M104 0h96v96h-96zM208 0h96v96h-96zM312 0h96v96h-96z"
})), /*#__PURE__*/react.createElement("g", {
  id: "Half"
}, /*#__PURE__*/react.createElement("path", {
  style: {
    fill: "#dcdce6"
  },
  d: "M48 0h48v96H48z",
  transform: "translate(416)"
}), stars_4_5_path3 || (stars_4_5_path3 = /*#__PURE__*/react.createElement("path", {
  className: "st0",
  d: "M0 0h48v96H0z",
  transform: "translate(416)"
}))), stars_4_5_path4 || (stars_4_5_path4 = /*#__PURE__*/react.createElement("path", {
  id: "Shape",
  className: "st2",
  d: "M48 64.7 62.6 61l6.1 18.8L48 64.7zm33.6-24.3H55.9L48 16.2l-7.9 24.2H14.4l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15z"
})), stars_4_5_path5 || (stars_4_5_path5 = /*#__PURE__*/react.createElement("path", {
  className: "st2",
  d: "m152 64.7 14.6-3.7 6.1 18.8L152 64.7zm33.6-24.3h-25.7L152 16.2l-7.9 24.2h-25.7l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15zM256 64.7l14.6-3.7 6.1 18.8L256 64.7zm33.6-24.3h-25.7L256 16.2l-7.9 24.2h-25.7l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15zM360 64.7l14.6-3.7 6.1 18.8L360 64.7zm33.6-24.3h-25.7L360 16.2l-7.9 24.2h-25.7l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15zM464 64.7l14.6-3.7 6.1 18.8L464 64.7zm33.6-24.3h-25.7L464 16.2l-7.9 24.2h-25.7l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15z"
})))));
/* harmony default export */ var stars_4_5 = (SvgStars45);
;// CONCATENATED MODULE: ../../../libs/consumer-lending/feature-car-finance/src/lib/components/trustpilot-score/stars/assets/stars-4.svg
var _g;
function stars_4_extends() { stars_4_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return stars_4_extends.apply(this, arguments); }

const SvgStars4 = props => /*#__PURE__*/react.createElement("svg", stars_4_extends({
  width: 512,
  height: 96,
  viewBox: "0 0 512 96",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/react.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/react.createElement("path", {
  fill: "#73CF11",
  d: "M0 0h96v96H0zM104 0h96v96h-96zM208 0h96v96h-96zM312 0h96v96h-96z"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#DCDCE6",
  d: "M416 0h96v96h-96z"
}), /*#__PURE__*/react.createElement("path", {
  d: "M48 64.7 62.6 61l6.1 18.8L48 64.7Zm33.6-24.3H55.9L48 16.2l-7.9 24.2H14.4l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15ZM152 64.7l14.6-3.7 6.1 18.8L152 64.7Zm33.6-24.3h-25.7L152 16.2l-7.9 24.2h-25.7l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15ZM256 64.7l14.6-3.7 6.1 18.8L256 64.7Zm33.6-24.3h-25.7L256 16.2l-7.9 24.2h-25.7l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15ZM360 64.7l14.6-3.7 6.1 18.8L360 64.7Zm33.6-24.3h-25.7L360 16.2l-7.9 24.2h-25.7l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15ZM464 64.7l14.6-3.7 6.1 18.8L464 64.7Zm33.6-24.3h-25.7L464 16.2l-7.9 24.2h-25.7l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15Z",
  fill: "#FFF"
})))));
/* harmony default export */ var stars_4 = (SvgStars4);
;// CONCATENATED MODULE: ../../../libs/consumer-lending/feature-car-finance/src/lib/components/trustpilot-score/stars/assets/stars-5.svg
var stars_5_g;
function stars_5_extends() { stars_5_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return stars_5_extends.apply(this, arguments); }

const SvgStars5 = props => /*#__PURE__*/react.createElement("svg", stars_5_extends({
  width: 512,
  height: 96,
  viewBox: "0 0 512 96",
  xmlns: "http://www.w3.org/2000/svg"
}, props), stars_5_g || (stars_5_g = /*#__PURE__*/react.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/react.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/react.createElement("path", {
  fill: "#00B67A",
  d: "M0 0h96v96H0zM104 0h96v96h-96zM208 0h96v96h-96zM312 0h96v96h-96zM416 0h96v96h-96z"
}), /*#__PURE__*/react.createElement("path", {
  d: "M48 64.7 62.6 61l6.1 18.8L48 64.7Zm33.6-24.3H55.9L48 16.2l-7.9 24.2H14.4l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15ZM152 64.7l14.6-3.7 6.1 18.8L152 64.7Zm33.6-24.3h-25.7L152 16.2l-7.9 24.2h-25.7l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15ZM256 64.7l14.6-3.7 6.1 18.8L256 64.7Zm33.6-24.3h-25.7L256 16.2l-7.9 24.2h-25.7l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15ZM360 64.7l14.6-3.7 6.1 18.8L360 64.7Zm33.6-24.3h-25.7L360 16.2l-7.9 24.2h-25.7l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15ZM464 64.7l14.6-3.7 6.1 18.8L464 64.7Zm33.6-24.3h-25.7L464 16.2l-7.9 24.2h-25.7l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15Z",
  fill: "#FFF"
})))));
/* harmony default export */ var stars_5 = (SvgStars5);
;// CONCATENATED MODULE: ../../../libs/consumer-lending/feature-car-finance/src/lib/components/trustpilot-score/stars/stars.tsx




const starSVGList = {
    4: /*#__PURE__*/ (0,jsx_runtime.jsx)(stars_4, {}),
    4.5: /*#__PURE__*/ (0,jsx_runtime.jsx)(stars_4_5, {}),
    5: /*#__PURE__*/ (0,jsx_runtime.jsx)(stars_5, {})
};
function TrustpilotStars({ className , starRating , starRatingLabel  }) {
    const alt = `${starRatingLabel} rating on Trustpilot`;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: className,
        "data-testid": "trustpilotStarsDefault",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            "aria-labelledby": "starRating",
            viewBox: "0 0 512 96",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    id: "starRating",
                    children: alt
                }),
                starSVGList[starRating] ?? /*#__PURE__*/ (0,jsx_runtime.jsx)(stars_5, {})
            ]
        })
    });
}
/* harmony default export */ var stars = (TrustpilotStars);

;// CONCATENATED MODULE: ../../../libs/consumer-lending/feature-car-finance/src/lib/components/trustpilot-score/assets/trustpilot-logo.svg
var trustpilot_logo_path, trustpilot_logo_path2, trustpilot_logo_path3;
function trustpilot_logo_extends() { trustpilot_logo_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return trustpilot_logo_extends.apply(this, arguments); }

const SvgTrustpilotLogo = props => /*#__PURE__*/react.createElement("svg", trustpilot_logo_extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1132.8 278.2"
}, props), trustpilot_logo_path || (trustpilot_logo_path = /*#__PURE__*/react.createElement("path", {
  d: "M297.7 98.6h114.7V120h-45.1v120.3h-24.8V120h-44.9V98.6zm109.8 39.1h21.2v19.8h.4c.7-2.8 2-5.5 3.9-8.1 1.9-2.6 4.2-5.1 6.9-7.2 2.7-2.2 5.7-3.9 9-5.3 3.3-1.3 6.7-2 10.1-2 2.6 0 4.5.1 5.5.2s2 .3 3.1.4v21.8c-1.6-.3-3.2-.5-4.9-.7-1.7-.2-3.3-.3-4.9-.3-3.8 0-7.4.8-10.8 2.3-3.4 1.5-6.3 3.8-8.8 6.7-2.5 3-4.5 6.6-6 11s-2.2 9.4-2.2 15.1v48.8h-22.6V137.7zm164 102.6h-22.2V226h-.4c-2.8 5.2-6.9 9.3-12.4 12.4-5.5 3.1-11.1 4.7-16.8 4.7-13.5 0-23.3-3.3-29.3-10s-9-16.8-9-30.3v-65.1H504v62.9c0 9 1.7 15.4 5.2 19.1 3.4 3.7 8.3 5.6 14.5 5.6 4.8 0 8.7-.7 11.9-2.2 3.2-1.5 5.8-3.4 7.7-5.9 2-2.4 3.4-5.4 4.3-8.8.9-3.4 1.3-7.1 1.3-11.1v-59.5h22.6v102.5zm38.5-32.9c.7 6.6 3.2 11.2 7.5 13.9 4.4 2.6 9.6 4 15.7 4 2.1 0 4.5-.2 7.2-.5s5.3-1 7.6-1.9c2.4-.9 4.3-2.3 5.9-4.1 1.5-1.8 2.2-4.1 2.1-7-.1-2.9-1.2-5.3-3.2-7.1-2-1.9-4.5-3.3-7.6-4.5-3.1-1.1-6.6-2.1-10.6-2.9-4-.8-8-1.7-12.1-2.6-4.2-.9-8.3-2.1-12.2-3.4-3.9-1.3-7.4-3.1-10.5-5.4-3.1-2.2-5.6-5.1-7.4-8.6-1.9-3.5-2.8-7.8-2.8-13 0-5.6 1.4-10.2 4.1-14 2.7-3.8 6.2-6.8 10.3-9.1 4.2-2.3 8.8-3.9 13.9-4.9 5.1-.9 10-1.4 14.6-1.4 5.3 0 10.4.6 15.2 1.7 4.8 1.1 9.2 2.9 13.1 5.5 3.9 2.5 7.1 5.8 9.7 9.8 2.6 4 4.2 8.9 4.9 14.6h-23.6c-1.1-5.4-3.5-9.1-7.4-10.9-3.9-1.9-8.4-2.8-13.4-2.8-1.6 0-3.5.1-5.7.4-2.2.3-4.2.8-6.2 1.5-1.9.7-3.5 1.8-4.9 3.2-1.3 1.4-2 3.2-2 5.5 0 2.8 1 5 2.9 6.7 1.9 1.7 4.4 3.1 7.5 4.3 3.1 1.1 6.6 2.1 10.6 2.9 4 .8 8.1 1.7 12.3 2.6 4.1.9 8.1 2.1 12.1 3.4 4 1.3 7.5 3.1 10.6 5.4 3.1 2.3 5.6 5.1 7.5 8.5 1.9 3.4 2.9 7.7 2.9 12.7 0 6.1-1.4 11.2-4.2 15.5-2.8 4.2-6.4 7.7-10.8 10.3-4.4 2.6-9.4 4.6-14.8 5.8-5.4 1.2-10.8 1.8-16.1 1.8-6.5 0-12.5-.7-18-2.2-5.5-1.5-10.3-3.7-14.3-6.6-4-3-7.2-6.7-9.5-11.1-2.3-4.4-3.5-9.7-3.7-15.8H610zm74.6-69.7h17.1v-30.8h22.6v30.8h20.4v16.9h-20.4v54.8c0 2.4.1 4.4.3 6.2.2 1.7.7 3.2 1.4 4.4.7 1.2 1.8 2.1 3.3 2.7 1.5.6 3.4.9 6 .9 1.6 0 3.2 0 4.8-.1 1.6-.1 3.2-.3 4.8-.7v17.5c-2.5.3-5 .5-7.3.8-2.4.3-4.8.4-7.3.4-6 0-10.8-.6-14.4-1.7-3.6-1.1-6.5-2.8-8.5-5-2.1-2.2-3.4-4.9-4.2-8.2-.7-3.3-1.2-7.1-1.3-11.3v-60.5h-17.1v-17.1zm76.1 0h21.4v13.9h.4c3.2-6 7.6-10.2 13.3-12.8 5.7-2.6 11.8-3.9 18.5-3.9 8.1 0 15.1 1.4 21.1 4.3 6 2.8 11 6.7 15 11.7 4 5 6.9 10.8 8.9 17.4 2 6.6 3 13.7 3 21.2 0 6.9-.9 13.6-2.7 20-1.8 6.5-4.5 12.2-8.1 17.2-3.6 5-8.2 8.9-13.8 11.9-5.6 3-12.1 4.5-19.7 4.5-3.3 0-6.6-.3-9.9-.9-3.3-.6-6.5-1.6-9.5-2.9-3-1.3-5.9-3-8.4-5.1-2.6-2.1-4.7-4.5-6.5-7.2h-.4v51.2h-22.6V137.7zm79 51.4c0-4.6-.6-9.1-1.8-13.5-1.2-4.4-3-8.2-5.4-11.6-2.4-3.4-5.4-6.1-8.9-8.1-3.6-2-7.7-3.1-12.3-3.1-9.5 0-16.7 3.3-21.5 9.9-4.8 6.6-7.2 15.4-7.2 26.4 0 5.2.6 10 1.9 14.4 1.3 4.4 3.1 8.2 5.7 11.4 2.5 3.2 5.5 5.7 9 7.5 3.5 1.9 7.6 2.8 12.2 2.8 5.2 0 9.5-1.1 13.1-3.2 3.6-2.1 6.5-4.9 8.8-8.2 2.3-3.4 4-7.2 5-11.5.9-4.3 1.4-8.7 1.4-13.2zm39.9-90.5h22.6V120h-22.6V98.6zm0 39.1h22.6v102.6h-22.6V137.7zm42.8-39.1H945v141.7h-22.6V98.6zm91.9 144.5c-8.2 0-15.5-1.4-21.9-4.1-6.4-2.7-11.8-6.5-16.3-11.2-4.4-4.8-7.8-10.5-10.1-17.1-2.3-6.6-3.5-13.9-3.5-21.8 0-7.8 1.2-15 3.5-21.6 2.3-6.6 5.7-12.3 10.1-17.1 4.4-4.8 9.9-8.5 16.3-11.2 6.4-2.7 13.7-4.1 21.9-4.1s15.5 1.4 21.9 4.1c6.4 2.7 11.8 6.5 16.3 11.2 4.4 4.8 7.8 10.5 10.1 17.1 2.3 6.6 3.5 13.8 3.5 21.6 0 7.9-1.2 15.2-3.5 21.8-2.3 6.6-5.7 12.3-10.1 17.1-4.4 4.8-9.9 8.5-16.3 11.2-6.4 2.7-13.7 4.1-21.9 4.1zm0-17.9c5 0 9.4-1.1 13.1-3.2 3.7-2.1 6.7-4.9 9.1-8.3 2.4-3.4 4.1-7.3 5.3-11.6 1.1-4.3 1.7-8.7 1.7-13.2 0-4.4-.6-8.7-1.7-13.1s-2.9-8.2-5.3-11.6c-2.4-3.4-5.4-6.1-9.1-8.2-3.7-2.1-8.1-3.2-13.1-3.2s-9.4 1.1-13.1 3.2c-3.7 2.1-6.7 4.9-9.1 8.2-2.4 3.4-4.1 7.2-5.3 11.6-1.1 4.4-1.7 8.7-1.7 13.1 0 4.5.6 8.9 1.7 13.2 1.1 4.3 2.9 8.2 5.3 11.6 2.4 3.4 5.4 6.2 9.1 8.3 3.7 2.2 8.1 3.2 13.1 3.2zm58.4-87.5h17.1v-30.8h22.6v30.8h20.4v16.9h-20.4v54.8c0 2.4.1 4.4.3 6.2.2 1.7.7 3.2 1.4 4.4.7 1.2 1.8 2.1 3.3 2.7 1.5.6 3.4.9 6 .9 1.6 0 3.2 0 4.8-.1 1.6-.1 3.2-.3 4.8-.7v17.5c-2.5.3-5 .5-7.3.8-2.4.3-4.8.4-7.3.4-6 0-10.8-.6-14.4-1.7-3.6-1.1-6.5-2.8-8.5-5-2.1-2.2-3.4-4.9-4.2-8.2-.7-3.3-1.2-7.1-1.3-11.3v-60.5h-17.1v-17.1z",
  fill: "#191919"
})), trustpilot_logo_path2 || (trustpilot_logo_path2 = /*#__PURE__*/react.createElement("path", {
  fill: "#00b67a",
  d: "M271.3 98.6H167.7L135.7 0l-32.1 98.6L0 98.5l83.9 61L51.8 258l83.9-60.9 83.8 60.9-32-98.5 83.8-60.9z"
})), trustpilot_logo_path3 || (trustpilot_logo_path3 = /*#__PURE__*/react.createElement("path", {
  fill: "#005128",
  d: "m194.7 181.8-7.2-22.3-51.8 37.6z"
})));
/* harmony default export */ var trustpilot_logo = (SvgTrustpilotLogo);
// EXTERNAL MODULE: ../../../libs/consumer-lending/feature-car-finance/src/lib/components/trustpilot-score/trustpilot-score.module.css
var trustpilot_score_module = __webpack_require__(90826);
var trustpilot_score_module_default = /*#__PURE__*/__webpack_require__.n(trustpilot_score_module);
;// CONCATENATED MODULE: ../../../libs/consumer-lending/feature-car-finance/src/lib/components/trustpilot-score/trustpilot-score.tsx







const TRUSTPILOT_URL = "/customer-reviews";
function TrustpilotScore({ numberOfReviews , starRating , starRatingLabel , className  }) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* Wrapper */.im, {
        className: {
            container: className
        },
        "data-testid": "trust-pilot-score",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: TRUSTPILOT_URL,
            target: "_blank",
            rel: "noreferrer",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (trustpilot_score_module_default()).container,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                        children: [
                            "Check out our ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: (0,util_src/* formatNumber */.uf)(numberOfReviews)
                            }),
                            " reviews"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(stars, {
                        className: (trustpilot_score_module_default()).trustpilotStars,
                        starRatingLabel: starRatingLabel,
                        starRating: starRating
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(trustpilot_logo, {
                        className: (trustpilot_score_module_default()).trustpilotLogo
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var trustpilot_score = (TrustpilotScore);

// EXTERNAL MODULE: ../../../libs/consumer-lending/feature-car-finance/src/lib/components/understand-car-finance/understand-car-finance.module.css
var understand_car_finance_module = __webpack_require__(25855);
var understand_car_finance_module_default = /*#__PURE__*/__webpack_require__.n(understand_car_finance_module);
;// CONCATENATED MODULE: ../../../libs/consumer-lending/feature-car-finance/src/lib/components/understand-car-finance/understand-car-finance.tsx








function renderBoldP(text) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
        fontWeight: index_esm/* TextFontWeights.bold */.Ax.bold,
        fontSize: index_esm/* TextFontSizes.l */.Xo.l,
        className: (understand_car_finance_module_default()).boldText,
        lineHeight: index_esm/* TextLineHeights.display */.ET.display,
        children: text
    }, text);
}
function renderP(text) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
        fontSize: index_esm/* TextFontSizes.m */.Xo.m,
        fontWeight: index_esm/* TextFontWeights.book */.Ax.book,
        className: (understand_car_finance_module_default()).text,
        children: text
    }, text);
}
function renderH4(text) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
        element: "h4",
        fontWeight: index_esm/* TextFontWeights.bold */.Ax.bold,
        lineHeight: index_esm/* TextLineHeights.display */.ET.display,
        fontSize: index_esm/* TextFontSizes.l */.Xo.l,
        className: (understand_car_finance_module_default()).smallTitle,
        children: text
    }, text);
}
function renderTip(text) {
    const content = text.split("<split>");
    if (content.length > 1) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Tip */.Ch, {
            titleEl: "p",
            title: content[0],
            text: content[1],
            classNames: {
                container: (understand_car_finance_module_default()).info
            }
        }, text);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Tip */.Ch, {
        text: content[0],
        classNames: {
            container: (understand_car_finance_module_default()).info
        }
    }, text);
}
function renderList(list) {
    const items = list.split("<split>");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* List */.aV, {
        items: items,
        textProps: {
            fontSize: index_esm/* TextFontSizes.m */.Xo.m
        },
        classNames: {
            list: (understand_car_finance_module_default()).list,
            item: (understand_car_finance_module_default()).items
        }
    }, list);
}
function renderBoldAndNormalText(text) {
    const content = text.split("<bold>");
    if (content.length > 1) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                    element: "span",
                    fontSize: index_esm/* TextFontSizes.m */.Xo.m,
                    fontWeight: index_esm/* TextFontWeights.bold */.Ax.bold,
                    className: (understand_car_finance_module_default()).boldText,
                    children: content[0]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                    element: "span",
                    fontSize: index_esm/* TextFontSizes.m */.Xo.m,
                    className: (understand_car_finance_module_default()).text,
                    children: content[1]
                })
            ]
        }, text);
    }
    return renderP(text);
}
function UnderstandingCarFinance({ i18n  }) {
    const { title , sections , ariaLabel  } = i18n;
    const { trackEvent  } = (0,analytics_src/* useAnalytics */.z$)();
    const rteTags = {
        list: renderList,
        info: renderTip,
        h4: renderH4,
        p: renderP,
        boldP: renderBoldP,
        pcpLink: renderPcpLink,
        hpLink: renderHpLink,
        boldAndNormalText: renderBoldAndNormalText
    };
    function renderPcpLink(text) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
            className: (understand_car_finance_module_default()).linkText,
            element: "p",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "car-finance/personal-contract-purchase",
                passHref: true,
                legacyBehavior: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    target: "_blank",
                    rel: "noreferrer noopener",
                    href: "car-finance/personal-contract-purchase",
                    onClick: ()=>trackEvent(calculatorPcpExplainedSelected()),
                    children: text
                })
            })
        }, text);
    }
    function renderHpLink(text) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
            className: (understand_car_finance_module_default()).linkText,
            element: "p",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/car-finance/hire-purchase",
                passHref: true,
                legacyBehavior: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    target: "_blank",
                    rel: "noreferrer noopener",
                    href: "/car-finance/hire-purchase",
                    onClick: ()=>trackEvent(calculatorHpExplainedSelected()),
                    children: text
                })
            })
        }, text);
    }
    function renderRte(content) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (understand_car_finance_module_default()).stack,
            children: (0,util_src/* interpolateI18n */.uR)(content, undefined, rteTags)
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
        className: (understand_car_finance_module_default()).understandingFinance,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* Wrapper */.im, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                "aria-labelledby": "understand-car-finance-title",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                        element: "h2",
                        fontSize: index_esm/* TextFontSizes.4xl */.Xo["4xl"],
                        fontWeight: index_esm/* TextFontWeights.bold */.Ax.bold,
                        lineHeight: index_esm/* TextLineHeights.display */.ET.display,
                        className: (understand_car_finance_module_default()).understandingFinanceTitle,
                        id: "understand-car-finance-title",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* VerticalTabs */.ei, {
                        className: (understand_car_finance_module_default()).understandingFinanceVerticalTabs,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* VerticalTabsList */.wy, {
                                ariaLabel: ariaLabel,
                                children: sections.map((section, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* VerticalTabsButton */.rP, {
                                        id: `button-${index}`,
                                        panelId: `understanding-finance-${index}`,
                                        onActive: ()=>{
                                            trackEvent(understandingFinanceClick(title, section.title));
                                        },
                                        children: section.title
                                    }, `button-${index}`))
                            }),
                            sections.map((section, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* VerticalTabsPanel */.z8, {
                                    id: `understanding-finance-${index}`,
                                    buttonId: `button-${index}`,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* VerticalTabsTitle */.X8, {
                                            children: section.title
                                        }),
                                        renderRte(section.content)
                                    ]
                                }, `understanding-finance-${index}`))
                        ]
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var understand_car_finance = (UnderstandingCarFinance);

// EXTERNAL MODULE: ../../../node_modules/next/head.js
var head = __webpack_require__(46582);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../../node_modules/next/router.js
var next_router = __webpack_require__(35837);
;// CONCATENATED MODULE: ../../../libs/consumer-lending/feature-car-finance/src/lib/components/head/head.tsx



const withTitleSuffix = (title)=>title.includes("- cinch") ? title : `${title} - cinch`;
const CarFinanceHead = ({ title , fallbackTitle , description , fallbackDescription , canonicalUrl , robots , openGraph , twitterCard , generatedAt , HowTo  })=>{
    const router = (0,next_router.useRouter)();
    const ogData = openGraph === null || openGraph === void 0 ? void 0 : openGraph[0];
    const twitterCardData = twitterCard === null || twitterCard === void 0 ? void 0 : twitterCard[0];
    const pathname = (router === null || router === void 0 ? void 0 : router.asPath) ?? "";
    canonicalUrl = !canonicalUrl ? `https://www.cinch.co.uk${pathname.split("?")[0]}` : canonicalUrl;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: withTitleSuffix(title || fallbackTitle)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: description || fallbackDescription
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "robots",
                content: (robots === null || robots === void 0 ? void 0 : robots.join(", ")) || "all"
            }, "robots"),
            generatedAt && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "page_generated_at",
                content: `${generatedAt}`
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "icon",
                href: "/favicon-32x32-bfc05e34c2d7531ace62bdb1cc158dfe.png"
            }),
            ((ogData === null || ogData === void 0 ? void 0 : ogData.title) || (ogData === null || ogData === void 0 ? void 0 : ogData.type)) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:url",
                content: `https://www.cinch.co.uk${pathname}`
            }),
            (ogData === null || ogData === void 0 ? void 0 : ogData.type) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:type",
                content: ogData.type
            }),
            (ogData === null || ogData === void 0 ? void 0 : ogData.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: ogData.title
            }),
            (ogData === null || ogData === void 0 ? void 0 : ogData.description) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:description",
                content: ogData.description
            }),
            (ogData === null || ogData === void 0 ? void 0 : ogData.imageUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:image",
                content: ogData.imageUrl
            }),
            (ogData === null || ogData === void 0 ? void 0 : ogData.imageAlt) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:image:alt",
                content: ogData.imageAlt
            }),
            (twitterCardData === null || twitterCardData === void 0 ? void 0 : twitterCardData.card) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:card",
                content: twitterCardData.card
            }),
            (twitterCardData === null || twitterCardData === void 0 ? void 0 : twitterCardData.card) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:site",
                content: "@cinchuk"
            }),
            (twitterCardData === null || twitterCardData === void 0 ? void 0 : twitterCardData.card) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "twitter:domain",
                content: "cinch.co.uk"
            }),
            (twitterCardData === null || twitterCardData === void 0 ? void 0 : twitterCardData.card) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "twitter:url",
                content: `https://www.cinch.co.uk${pathname}`
            }),
            (twitterCardData === null || twitterCardData === void 0 ? void 0 : twitterCardData.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:title",
                content: twitterCardData === null || twitterCardData === void 0 ? void 0 : twitterCardData.title
            }),
            (twitterCardData === null || twitterCardData === void 0 ? void 0 : twitterCardData.description) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:description",
                content: twitterCardData === null || twitterCardData === void 0 ? void 0 : twitterCardData.description
            }),
            (twitterCardData === null || twitterCardData === void 0 ? void 0 : twitterCardData.imageUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:image",
                content: twitterCardData === null || twitterCardData === void 0 ? void 0 : twitterCardData.imageUrl
            }),
            (twitterCardData === null || twitterCardData === void 0 ? void 0 : twitterCardData.imageAlt) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:image:alt",
                content: twitterCardData === null || twitterCardData === void 0 ? void 0 : twitterCardData.imageAlt
            }),
             true && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: canonicalUrl
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "sitemap",
                        type: "application/xml",
                        href: "/sitemap.xml"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "manifest",
                        href: "/manifest.webmanifest",
                        crossOrigin: "anonymous"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var head_head = (CarFinanceHead);

;// CONCATENATED MODULE: ../../../libs/consumer-lending/feature-car-finance/src/lib/locales/index.ts
const defaultEndpoints = {
    staticAssetBaseUrl: "https://assets-production.cinch.co.uk"
};
const carFinanceHeadText = {
    fallbackTitle: "UK Car Financing: Buy and Finance your car online with us - cinch",
    fallbackDescription: "cinch offers a range of car finance options helping you buy your next car without the faff. Find your new car and get it with a low deposit and simple monthly repayments."
};
const understandCarFinance = {
    title: "Understanding car finance",
    ariaLabel: "My list items",
    sections: [
        {
            title: "How much car finance costs",
            content: `
      {boldP}The cost of your loan depends on:{/boldP}
      {list}how much the car costs<split>your deposit amount<split>the length of the term you choose - between 36 and 60 months<split>the interest rate you are offered.{/list}
      {info}APR (Annual Percentage Rate)<split>This means the amount of interest you’re charged each year, on top of what you’ve borrowed{/info}
      {p}You can also part-exchange your current car which will reduce the overall cost of your new car.{/p}
      {p}Make sure you can commit to the term of the loan, and that you can afford the monthly payments on top of your usual spending.{/p}
    `
        },
        {
            title: "What you’ll need to apply",
            content: `
      {boldP}To apply for car finance with cinch, you need to:{/boldP}
      {list}have a driving licence - full or provisional<split>apply with the same address that’s on your licence.{/list}
      {info}Car finance is subject to credit checks - it might be helpful to check your credit score before you apply{/info}
      {boldP}In the application, you’ll be asked for:{/boldP}
      {list}your name<split>date of birth and nationality<split>your recent address history<split>your employment status<split>your income and outgoings.{/list}
      {p}You’ll also be asked for your bank account details - this is so we can check that it’s really you applying.{/p}
      {p}When you submit, your application will go to our panel of lenders to see if they can offer you finance and could take up to 3 credit checks to find the right lender for you. This could temporarily reduce your ability to be approved for further credit.{/p}
    `
        },
        {
            title: "Confirming your offer",
            content: `
      {p}You’ll get an email to let you know if you’ve been approved or not. You can then view your finance offer.{/p}
      {p}Your tailored finance offer will show all the details of your loan.{/p}
      {p}If you’re happy with the offer, you’ll have 5 days to confirm it and sign.{/p}
      {h4}ID check and sign{/h4}
      {p}To confirm your offer, you’ll need to upload your ID for a check and sign digitally with our lender.{/p}
      {boldP}At this stage, you will need to:{/boldP}
      {list}upload a photo of your ID, like passport or driving licence<split>and upload a photo of your signature.<split>and then come back to cinch to book your delivery.{/list}
    `
        },
        {
            title: "HP and PCP: what’s the difference?",
            content: `
      {p}HP (Hire Purchase) and PCP (Personal Contract Purchase) are types of loans that help you pay for a car.{/p}
      {p}At cinch, you can choose to pay over 36 to 60 months.{/p}
      {boldP}With HP you:{/boldP}
      {list}pay monthly payments over a set time<split>own your car at the end of the plan.<split>you usually have to pay a small 'option to purchase' fee at the end of your HP plan. For Conditional Sale agreements, there is no such fee.{/list}
      {boldAndNormalText}If you want to end the agreement early<bold> - wear and tear charges may apply.{/boldAndNormalText}
      {hpLink}Learn more about HP car finance{/hpLink}
      {boldP}With PCP you:{/boldP}
      {list}pay monthly payments over a set time<split>keep, hand back or part exchange the car at the end - with an optional final payment if you choose to keep the car.{/list}
      {boldAndNormalText}If you want to hand back the car<bold> - this is subject to mileage and condition (excess mileage and damage charges may apply).{/boldAndNormalText}
      {boldAndNormalText}If you part exchange at the end<bold>  - this is subject to paying off your existing finance agreement and new credit agreements. New credit agreements are subject to status.{/boldAndNormalText}
      {pcpLink}Learn more about PCP car finance{/pcpLink}
      {info}It's important to give an accurate mileage if you apply for PCP. If you drive more miles, you'll have to pay an excess mileage charge{/info}
      {boldP}What's the difference between Hire Purchase (HP) and Conditional Sale (CS)?{/boldP}
      {p}When taking out a HP agreement, this may also include  a 'Condition Sale'.{/p}
      {p}Both HP and CS need monthly payments to cover the cost of the car, and with both contracts you'll be the legal owner of the car when you're all paid up.{/p}
      {p}HP  has a small 'option to purchase' fee included in your final payment, while CS has no such payment. You'll be aware of your 'option to purchase' fee at the start of your HP contract, so don't worry about being hit with large hidden costs.{/p}
      {p}CS only applies to HP finance, not PCP finance.{/p}
      {p}With any car finance agreement, it'll all be laid out in front of you right at the start.{/p}
    `
        }
    ]
};
const howItWorks = {
    title: "How it works",
    text: "You can apply for finance once you’ve chosen your car and selected ‘Buy now’. Here’s how it works.",
    steps: [
        {
            title: "Get a quote",
            splitText: [
                "Use our calculator to get a finance quote with ",
                " plans to suit you. Deposit from as little as \xa30, use your part-exchange as deposit or top-up with extra cash if you need to."
            ]
        },
        {
            title: "Apply online",
            text: "When you apply, we’ll ask about things like address history and affordability to get you a tailored finance offer."
        },
        {
            title: "Get a decision",
            text: "Your application is sent off to our panel of lenders who will complete up to 3 credit searches. We’ll usually let you know within 24 hours if it has been approved."
        },
        {
            title: "Your offer",
            text: "To confirm your offer, you’ll need to do a digital ID check and sign. You have 5 days to do this while your car is reserved."
        }
    ]
};
const lenderPartners = {
    title: "Our lending partners",
    text: "Our trusted partners work hard to find the right finance plan for you.",
    endpoints: defaultEndpoints
};
const readyToGetCarFinance = {
    title: "Ready to get car finance?",
    text: "When you've chosen your new car, select 'Pay with finance' in checkout.",
    searchButtonText: "Search all cars"
};
const findACar = {
    title: "Find a car to suit your budget",
    alt: "Image of a woman with a car key",
    searchSection: {
        subtitle: "Search by finance type",
        PCP: {
            label: "PCP (Personal Contract Purchase)",
            sublabel: "Option to buy at the end, usually has lower monthly payments"
        },
        HP: {
            label: "HP (Hire Purchase)",
            sublabel: "Keep the car at the end, usually has higher monthly payments"
        }
    },
    inputSection: {
        subtitle: "Enter your monthly budget",
        description: "Based on a \xa32,000 deposit on a 48 month plan with a representative APR 11.4%, \xa310 option-to-purchase fee and fixed interest rate of 11.4%. Subject to credit checks. Deposit amount for illustrative purposes only. The amount of deposit used towards your finance agreement may affect monthly payments.",
        hpBudgetDescription: "Search for a car {b}up to {calculateHpCarPrice}{/b} with a {budget} monthly budget on a HP plan."
    },
    cta: {
        default: "Search all cars",
        active: {
            message: "Search for cars up to {budget}",
            suffix: {
                short: "/pm",
                long: " a month",
                aria: " per month"
            }
        }
    }
};
const findACarCta = {
    ctaText: "Find a car to suit your budget"
};
const financeExplained = {
    sectionTitle: "Finance explained",
    videoTitle: "Car Finance - ways to buy",
    cta: {
        start: "Play",
        end: "from Youtube"
    }
};
const carFinancePageText = {
    understandCarFinance,
    howItWorks,
    lenderPartners,
    readyToGetCarFinance,
    findACar,
    findACarCta,
    financeExplained,
    carFinanceHeadText
};

// EXTERNAL MODULE: ../../../libs/data/trustpilot/src/index.ts + 6 modules
var trustpilot_src = __webpack_require__(99649);
// EXTERNAL MODULE: ../../../libs/shared/environments/src/index.ts + 5 modules
var environments_src = __webpack_require__(48114);
// EXTERNAL MODULE: ../../../libs/consumer-lending/feature-car-finance/src/lib/feature-car-finance.module.css
var feature_car_finance_module = __webpack_require__(48212);
var feature_car_finance_module_default = /*#__PURE__*/__webpack_require__.n(feature_car_finance_module);
;// CONCATENATED MODULE: ../../../libs/consumer-lending/feature-car-finance/src/lib/feature-car-finance.tsx
















function FeatureCarFinance({ trustpilotData  }) {
    const findACarRef = (0,react.useRef)(null);
    const cinchStarRating = (0,trustpilot_src/* useTrustpilotScore */.b6)();
    const showTrustPilotScoreless = (0,environments_src/* readFromEnv */.u)(environments_src/* Env.ShowScorelessTrustpilot */.X.ShowScorelessTrustpilot) === "true";
    const showTruspilotScoreless = cinchStarRating ? showTrustPilotScoreless || cinchStarRating <= 4.2 : showTrustPilotScoreless;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(head_head, {
                fallbackTitle: carFinancePageText.carFinanceHeadText.fallbackTitle,
                fallbackDescription: carFinancePageText.carFinanceHeadText.fallbackDescription
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(find_a_car_cta, {
                i18n: carFinancePageText.findACarCta,
                triggerPointRef: findACarRef
            }),
            trustpilotData && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (feature_car_finance_module_default()).trustPilotWrapper,
                children: showTruspilotScoreless ? /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* TrustpilotScoreless */.jP, {
                    shouldShowFirstLine: false,
                    numberOfReviews: trustpilotData.totalReviews
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(trustpilot_score, {
                    numberOfReviews: trustpilotData.totalReviews,
                    starRatingLabel: trustpilotData.starRatingLabel,
                    starRating: trustpilotData.starRating
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(how_it_works, {
                i18n: carFinancePageText.howItWorks
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: findACarRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(find_a_car, {
                    i18n: carFinancePageText.findACar
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(finance_explained, {
                i18n: carFinancePageText.financeExplained
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(understand_car_finance, {
                i18n: carFinancePageText.understandCarFinance
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(finance_lenders, {
                i18n: carFinancePageText.lenderPartners
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ready_to_get_car_finance, {
                i18n: carFinancePageText.readyToGetCarFinance
            })
        ]
    });
}
/* harmony default export */ var feature_car_finance = ((/* unused pure expression or super */ null && (FeatureCarFinance)));

;// CONCATENATED MODULE: ../../../libs/consumer-lending/feature-car-finance/src/lib/storyblok/static-content.ts
const story = {
    content: {
        cfHero: [
            {
                title: "Car finance",
                body: {
                    type: "doc",
                    content: [
                        {
                            type: "paragraph",
                            content: [
                                {
                                    text: "Spread the cost of your car over 36 to 60 months, with flexible deposits and ",
                                    type: "text",
                                    marks: [
                                        {
                                            type: "textStyle",
                                            attrs: {
                                                color: "rgb(25, 29, 23)"
                                            }
                                        }
                                    ]
                                },
                                {
                                    text: "HP (Hire purchase)",
                                    type: "text",
                                    marks: [
                                        {
                                            type: "link",
                                            attrs: {
                                                href: "/car-finance/hire-purchase",
                                                uuid: null,
                                                anchor: null,
                                                target: "_blank",
                                                linktype: "url"
                                            }
                                        },
                                        {
                                            type: "textStyle",
                                            attrs: {
                                                color: "rgb(25, 29, 23)"
                                            }
                                        }
                                    ]
                                },
                                {
                                    text: " or ",
                                    type: "text",
                                    marks: [
                                        {
                                            type: "textStyle",
                                            attrs: {
                                                color: "rgb(25, 29, 23)"
                                            }
                                        }
                                    ]
                                },
                                {
                                    text: "PCP (Personal Contract Purchase)",
                                    type: "text",
                                    marks: [
                                        {
                                            type: "link",
                                            attrs: {
                                                href: "/car-finance/personal-contract-purchase",
                                                uuid: null,
                                                anchor: null,
                                                target: "_blank",
                                                linktype: "url"
                                            }
                                        },
                                        {
                                            type: "textStyle",
                                            attrs: {
                                                color: "rgb(25, 29, 23)"
                                            }
                                        }
                                    ]
                                },
                                {
                                    text: " plans ",
                                    type: "text",
                                    marks: [
                                        {
                                            type: "textStyle",
                                            attrs: {
                                                color: "rgb(25, 29, 23)"
                                            }
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                image: {
                    filename: "/images/car-finance-bmw-pound-sign.png",
                    alt: "Blue BMW car with pound sign floating above it"
                },
                component: "CarFinanceHero"
            }
        ]
    }
};

// EXTERNAL MODULE: ../../../libs/core/datadog-server/src/index.ts + 7 modules
var datadog_server_src = __webpack_require__(86634);
;// CONCATENATED MODULE: ../../../libs/consumer-lending/feature-car-finance/src/lib/get-static-props.ts



async function getStaticPropsfn({ preview =false  }) {
    const ddMeta = {
        traceId: (0,datadog_server_src/* getTraceId */.Wj)(),
        traceTime: Date.now()
    };
    const { stars: starRating , starRatingLabel , total: totalReviews  } = await (0,trustpilot_src/* getReviews */.Jh)();
    try {
        var ref, ref1;
        const HeroProps = (ref = story.content) === null || ref === void 0 ? void 0 : (ref1 = ref.cfHero) === null || ref1 === void 0 ? void 0 : ref1[0];
        (0,datadog_server_src/* setTag */.YA)("response.code", 200);
        return {
            props: {
                story: story,
                trustpilotData: {
                    starRatingLabel,
                    totalReviews,
                    starRating
                },
                layoutProps: {
                    heroProps: HeroProps,
                    showBorderRadius: true
                }
            },
            revalidate: 60
        };
    } catch (error) {
        console.error(error);
        if (typeof error === "string" || error instanceof Error) {
            (0,datadog_server_src/* tagError */.$k)(error);
        }
        return {
            notFound: true,
            props: {
                ddMeta
            },
            revalidate: 30
        };
    }
}
const getStaticProps = (0,datadog_server_src/* traceFunction */.KG)("car-finance.getStaticProps", getStaticPropsfn);

;// CONCATENATED MODULE: ../../../libs/consumer-lending/feature-car-finance/src/index.ts



;// CONCATENATED MODULE: ./pages/car-finance/index.tsx
var __N_SSG = true;



/***/ }),

/***/ 32857:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"youtubeWrapper":"finance-explained_youtubeWrapper__vhlCZ","youtubeWrapperTitle":"finance-explained_youtubeWrapperTitle__QK6um"};

/***/ }),

/***/ 65410:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"lendingPartners":"finance-lenders_lendingPartners__rj5z_","lendingPartnersMainTitle":"finance-lenders_lendingPartnersMainTitle__S02nF","lenderImagesContainer":"finance-lenders_lenderImagesContainer__ckgcE","lenderImages":"finance-lenders_lenderImages__L6VZQ","lenderImageItem":"finance-lenders_lenderImageItem__LZgz4","lenderImage":"finance-lenders_lenderImage__TS5GR"};

/***/ }),

/***/ 45214:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"findACarCtaContainer":"find-a-car-cta_findACarCtaContainer__2Yx7L","findACarCtaInner":"find-a-car-cta_findACarCtaInner__w12bq","findACarCta":"find-a-car-cta_findACarCta__oa9Qs"};

/***/ }),

/***/ 21714:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"findACar":"find-a-car_findACar__vzoy9","financeFeatureTitle":"find-a-car_financeFeatureTitle__HAtRn","financeFeaturePicture":"find-a-car_financeFeaturePicture__3sMLN","financeFeatureForm":"find-a-car_financeFeatureForm___CKOh","searchInputContainer":"find-a-car_searchInputContainer__MiDN9","budgetTypeOptionLegend":"find-a-car_budgetTypeOptionLegend__rE6qA","budgetTypeOptionsContainer":"find-a-car_budgetTypeOptionsContainer__4D3Fp","budgetTypeOptionRadioContainer":"find-a-car_budgetTypeOptionRadioContainer___y4bM","budgetTypeOptionRadioLabel":"find-a-car_budgetTypeOptionRadioLabel__TnnbK","budgetTypeText":"find-a-car_budgetTypeText__NOUGG","budgetTypeHidden":"find-a-car_budgetTypeHidden__1IJX8","searchInputLabel":"find-a-car_searchInputLabel__KB_DT","budgetDescription":"find-a-car_budgetDescription__CCYtu","searchDescription":"find-a-car_searchDescription__2EHfX","searchCtaLong":"find-a-car_searchCtaLong__tf23_","searchCtaShort":"find-a-car_searchCtaShort__vmEOr"};

/***/ }),

/***/ 31701:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"howItWorks":"how-it-works_howItWorks__zrLxl","howItWorksMainTitle":"how-it-works_howItWorksMainTitle__2X2Hn","howItWorksTitle":"how-it-works_howItWorksTitle__Gm4YQ","howItWorksImage":"how-it-works_howItWorksImage__lNXUw","howItWorksSteps":"how-it-works_howItWorksSteps__cxPwP","linkText":"how-it-works_linkText__tPCso"};

/***/ }),

/***/ 69314:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"readyToGetCarFinance":"ready-to-get-car-finance_readyToGetCarFinance__Xy3pH","readyToGetCarFinanceMainTitle":"ready-to-get-car-finance_readyToGetCarFinanceMainTitle__UGJOx","readyToGetCarFinanceButton":"ready-to-get-car-finance_readyToGetCarFinanceButton__p3AIl"};

/***/ }),

/***/ 90826:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"trustpilot-score_container__MH6MB","trustpilotStars":"trustpilot-score_trustpilotStars__zSClC","trustpilotLogo":"trustpilot-score_trustpilotLogo__loo49"};

/***/ }),

/***/ 25855:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"stack":"understand-car-finance_stack__i5bWb","info":"understand-car-finance_info__mTzHV","explainedLink":"understand-car-finance_explainedLink__XUYwJ","boldText":"understand-car-finance_boldText__miDSG","smallTitle":"understand-car-finance_smallTitle__syKzm","understandingFinanceTabs":"understand-car-finance_understandingFinanceTabs__4iYlr","text":"understand-car-finance_text__G1YwC","items":"understand-car-finance_items__7gbsO","understandingFinanceAccordion":"understand-car-finance_understandingFinanceAccordion__4An7E","understandingFinance":"understand-car-finance_understandingFinance__L_vqR","understandingFinanceTitle":"understand-car-finance_understandingFinanceTitle__AxUm5","linkText":"understand-car-finance_linkText__2YKOH"};

/***/ }),

/***/ 48212:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"feature-car-finance_container__5xRPl","trustPilotWrapper":"feature-car-finance_trustPilotWrapper__1nw8i"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1080,9774,2888,179], function() { return __webpack_exec__(46208); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);